module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/banner/zh-hant-ca01aeb5f4141297d9618d42f3d39f4e.jpg";